export var IconKind;
(function (IconKind) {
    IconKind["Gift"] = "Gift";
    IconKind["Mir"] = "Mir";
    IconKind["Cashback"] = "Cashback";
    IconKind["Diamond"] = "Diamond";
    IconKind["Pam"] = "Pam";
    IconKind["BedDouble"] = "BedDouble";
    IconKind["Book"] = "Book";
    IconKind["Info"] = "Info";
    IconKind["Success"] = "Success";
    IconKind["Service"] = "Service";
    IconKind["Signature"] = "Signature";
    IconKind["Discount"] = "Discount";
    IconKind["House"] = "House";
    IconKind["Doc"] = "Doc";
    IconKind["Fire"] = "Fire";
    IconKind["Journal"] = "Journal";
    IconKind["News"] = "News";
    IconKind["Crown"] = "Crown";
})(IconKind || (IconKind = {}));
